export const TENANT = 'nájemce'
export const BUYER = 'kupující'

export const ALL_COOPERATION_TYPES = [TENANT, BUYER] as const

export type CooperationType = (typeof ALL_COOPERATION_TYPES)[number]
